import type {TStore} from "modules/types/store";

export const getGameMessage = (store: TStore) => store.gameMessage.message;
